import { render, staticRenderFns } from "./FspAcknowledgeFormGraceView.vue?vue&type=template&id=72437c5e&"
import script from "./FspAcknowledgeFormGraceView.vue?vue&type=script&lang=js&"
export * from "./FspAcknowledgeFormGraceView.vue?vue&type=script&lang=js&"
import style0 from "./FspAcknowledgeFormGraceView.vue?vue&type=style&index=0&id=72437c5e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports